/** Appends today's date so repeated exports don't overwrite or pile up as "(1)", "(2)". */
export const withExportDate = (name: string): string =>
  `${name} - ${new Date().toLocaleDateString("en-CA")}`;
